<template>
  <div id="app">
    <router-view />
    <footer class="footer" v-show="!this.$store.state.webview">
      <div class="container">
        <div class="row">
          <div class="col-6">
            <span class="text-muted">&copy; {{ year }} University of Ilorin. All rights reserved.</span>
          </div>
          <div class="col-6 text-right">
            <span class="text-muted">Powered by <a href="http://esupport.ng" target="_blank">eSupport</a>.</span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('getWebview')
  },

  computed: {
    year() {
      let d = new Date()
      return d.getFullYear()
    }
  }
}
</script>

<style>
body {
  padding: 0;
  margin: 0;
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
.footer {
  font-size: 0.8rem;
}
</style>
